module.exports = __webpack_public_path__ + "img/01.eab98690.png";